import styled from 'styled-components';

const StyledDiv = styled.div`
  ${(props) => props.customStyles};
`;

export default StyledDiv;
